import { FunctionComponent, useCallback, useEffect, useState } from "react";
import TopNavbar from "src/components/TopNavbar";

import TopNavbarAdmin from "src/components/TopNavbarAdmin";
import {
  Button,
  Card,
  Container,
  Group,
  Select,
  Space,
  Stack,
  Text,
  TextInput,
  rem,
  useMantineTheme,
} from "@mantine/core"
import useAdminSettings from "src/hooks/useAdminSettings";
import { StyledContainer } from "src/components/common/StyledComponents/Container";
import { FeedbackComponent } from "src/components/common/Feedback";
import { StyledContainerInset } from "src/components/common/StyledComponents/BackgroundContainer";
import { COLORS, FONT_SIZES } from "src/utils/styles";
import useResponsive from "src/hooks/useResponsive";
import { FocusButton } from "src/components/common/Buttons/FocusButton";
import { ComplaintsTable } from "src/components/Tables/ComplaintsTable";
import { Complaints, ProcessedComplaint } from "src/interfaces/Complaints";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "src/navigators/routes/AdminRoutes";
import useComplaints from "src/hooks/useComplaints";
import { useAppDispatch } from "src/redux/redux-store/hooks";
import { updateSelectedComplaint } from "src/redux/redux-store";


const ComplaintCenter = () => {
  const navigate = useNavigate()  
  const {adminSettings, updateLLMConfig, error, feedback} = useAdminSettings()
  const [temperature, setTemperature] = useState(adminSettings?.llm_temperature.toString())
  const [role, setRole] = useState(adminSettings?.llm_role)
  const [model, setModel] = useState<string | null>(adminSettings.llm_model_name)
  const [prompt, setPrompt] = useState(adminSettings?.llm_prompt)
  const theme = useMantineTheme()
  const dispatch = useAppDispatch()
  const {processedComplaints} =  useComplaints()
  const {backgroundColor, backgroundColorExterior} = useResponsive()

  useEffect(() => {
    setRole(adminSettings?.llm_role)
    setPrompt(adminSettings?.llm_prompt)
    setTemperature(adminSettings?.llm_temperature.toString())
  }, [adminSettings])

  const viewComplaint = (item: ProcessedComplaint) => {
    dispatch(updateSelectedComplaint(item))
    navigate(`viewComplaint`);
  }

  return (
    <StyledContainer theme={{backgroundColor: backgroundColorExterior}}>
      <StyledContainerInset theme={{backgroundColor: backgroundColor}}>
        <div className= "p-4 h-[100%] overflow-y-auto">
        <Text size={FONT_SIZES.h1} fw={600}>Complaint Center</Text>
        <Text c="dimmed" size={14}>
         One place for all issues related to your bot.
         </Text>
         <Card bg={backgroundColor} p={0} my={"md"}>
            <Text>Existing Complaints</Text>
         </Card>
         <ComplaintsTable 
         handleItemPress={viewComplaint}
         data={processedComplaints.reverse()}
         />
        </div>
    </StyledContainerInset>
    </StyledContainer>
  );
};

export default ComplaintCenter;
